import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

import dayjs from 'dayjs';

//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";
import HeaderStepManager from "../../../commons/headerstepmanager/HeaderStepManager.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx";


//MUI Components
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { idSpotLocSlice } from "../../../store/idSpotLocSlice.js";
import { spotsListSlice } from "../../../store/spotsListSlice.js";
import { getIdSpotLoc } from "../../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//Utils
import { checkLogin } from '../../../utils/check-login.js'


function Manager() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const idSpotLoc = useSelector(getIdSpotLoc);
    //let listSpots = [];
    const [listSpots, setListSpots] = useState([]);

    const handleChange = (event) => {//when selected spot change
        dispatch(idSpotLocSlice.actions.setIdSpotLoc(event.target.value)); //update global state

    };



    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (checkLogin() === false) {
            navigate("/manager/login/home");
        }; // if no login, no token, go to login page

        axios.get(baseURL + "/spot").then((response) => {
            setListSpots(response.data);
            //dispatch(spotsListSlice.actions.setSpotsList(listSpots));
        });

    }, [])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        dispatch(spotsListSlice.actions.setSpotsList(listSpots));

    }, [listSpots])



    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            <HeaderStepManager title={"Selection du point de location"} />

            <div className="manager-home">

                <Box sx={{ minWidth: 120, display: 'flex', alignItems: 'center' }} >
                    <FormControl fullWidth >
                        <InputLabel id="demo-simple-select-label">Point de retrait/retour des vélos :</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={idSpotLoc > 0 ? idSpotLoc : ''} //MUI select does not want a '0' value (but ok for '')
                            label="Point de retrait/retour des vélos :"
                            onChange={handleChange}
                        >
                            {
                                listSpots.map((spot) => <MenuItem key={spot.id_spot} value={+spot.id_spot}>{spot.nom_spot}</MenuItem>)
                            }

                        </Select>
                    </FormControl>
                </Box>

            </div>

        </main>
    )
}




export default Manager